 <p-multiSelect 
    [options]="items"
    [(ngModel)]="relationshipDataGroupSelected"
    [defaultLabel]="processing ? 'Loading..' : defaultLabel"
    [filterPlaceHolder]="filterPlaceHolder"
    [disabled]="disabled || processing"
    [maxSelectedLabels]="maxSelectedLabels"
    (onChange)="change($event.value)"
    (onBlur)="blur()">
</p-multiSelect>